import { BiometryType } from '@aparajita/capacitor-biometric-auth'

export class User {
  email: string
  firstName: string
  lastName: string
  cognitoId: string
  stripeCustomerId: string
  stripeSubscriptionId?: string
  stripeSubscriptionStatus?: string
  stripePriceId?: string
  wantsMarketingEmails?: boolean

  constructor(
    email: string,
    firstName: string,
    lastName: string,
    cognitoId: string,
    stripeCustomerId: string,
    stripeSubscriptionId?: string,
    stripeSubscriptionStatus?: string,
    stripePriceId?: string,
    wantsMarketingEmails?: boolean,
  ) {
    this.email = email
    this.firstName = firstName
    this.lastName = lastName
    this.cognitoId = cognitoId
    this.stripeCustomerId = stripeCustomerId
    this.stripeSubscriptionId = stripeSubscriptionId
    this.stripeSubscriptionStatus = stripeSubscriptionStatus
    this.stripePriceId = stripePriceId
    this.wantsMarketingEmails = wantsMarketingEmails
  }
}

export interface BiometricCredential {
  username: string
  password: string
}

export enum BiometryTypesCustom {
  'none' = BiometryType.none,
  'Touch ID' = BiometryType.touchId,
  'Face ID' = BiometryType.faceId,
  'Fingerprint' = BiometryType.fingerprintAuthentication,
  'Face' = BiometryType.faceAuthentication,
  'Iris' = BiometryType.irisAuthentication,
}
